import React from 'react';

const PlinthionLogo = ({ size = 'default', className = '', showText = true, light = true }) => {
  const sizes = {
    small: { icon: 32, text: 'text-lg', gap: 'gap-2' },
    default: { icon: 40, text: 'text-xl', gap: 'gap-2' },
    large: { icon: 56, text: 'text-3xl', gap: 'gap-3' },
    xlarge: { icon: 80, text: 'text-5xl', gap: 'gap-4' }
  };

  const currentSize = sizes[size] || sizes.default;
  const primaryColor = light ? '#FFFFFF' : '#16207B';
  const accentColor = '#4ECDC4'; // Teal accent for contrast

  return (
    <div className={`flex items-center ${currentSize.gap} ${className}`}>
      {/* Logo Icon - Stylized P with warehouse/plinth concept */}
      <svg 
        width={currentSize.icon} 
        height={currentSize.icon} 
        viewBox="0 0 100 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Base Plinth - Foundation */}
        <rect x="10" y="75" width="80" height="12" rx="2" fill={primaryColor} opacity="0.95"/>
        
        {/* Middle Platform */}
        <rect x="18" y="60" width="64" height="10" rx="2" fill={primaryColor} opacity="0.85"/>
        
        {/* Stylized P shape - representing the brand */}
        <path 
          d="M30 15 L30 55 L38 55 L38 40 L55 40 C65 40 72 33 72 25 C72 17 65 10 55 10 L35 10 C32 10 30 12 30 15 Z M38 18 L55 18 C60 18 64 21 64 25 C64 29 60 32 55 32 L38 32 L38 18 Z"
          fill={primaryColor}
        />
        
        {/* Accent elements - representing connectivity/network */}
        <circle cx="78" cy="25" r="6" fill={accentColor}/>
        <rect x="70" y="23" width="8" height="4" fill={accentColor}/>
        
        {/* Small accent blocks - representing stacked goods */}
        <rect x="68" y="48" width="12" height="8" rx="1" fill={accentColor} opacity="0.9"/>
        <rect x="58" y="52" width="8" height="4" rx="1" fill={accentColor} opacity="0.7"/>
      </svg>
      
      {/* Text Logo */}
      {showText && (
        <span 
          className={`font-black ${currentSize.text} tracking-tight leading-none`}
          style={{ color: primaryColor }}
        >
          PLINTHION
        </span>
      )}
    </div>
  );
};

export default PlinthionLogo;
